<template>
  <div>
    <el-upload
      ref="apkUpload"
      action="#"
      :http-request="submitUpload"
      :on-change="handleChange"
      :on-progress="getProgress"
      :before-remove="beforeRemove"
      :on-remove="handleRemove"
      multiple
      :limit="1"
      :on-exceed="handleExceed"
      :file-list="fileList"
      v-loading="loading"
    >
      <el-button size="small" type="primary" plain>点击上传</el-button>
    </el-upload>
    <el-progress
      v-show="isTrue"
      :text-inside="true"
      :stroke-width="26"
      :percentage="percentage"
      :color="customColors"
      style="width: 30%;"
    ></el-progress>
  </div>
</template>

<!--suppress JSUnresolvedFunction -->
<script>
export default {
  name: "ApkUpload",
  data() {
    return {
      fileList: [],
      url: "",
      loading: false,
      customColors: [
        { color: "#f56c6c", percentage: 20 },
        { color: "#e6a23c", percentage: 40 },
        { color: "rgb(33, 187, 207)", percentage: 60 },
        { color: "#1989fa", percentage: 80 },
        { color: "rgb(81, 184, 81)", percentage: 100 }
      ], //颜色展示
      isTrue: false, //是否展示 滚动条
      percentage: 0 //滚动条数据
    };
  },
  methods: {
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    handleRemove() {
      this.url = "";
      this.$emit("onUploadApk");
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    submitUpload() {
      this.loading = true;
      let formData = new FormData();
      this.fileList.forEach(item => {
        formData.append("file", item.raw);
      });
      this.getProgress();
      this.axios.post("/game/apkUpload", formData).then(resp => {
        if (resp) {
          this.url = resp.data;
          this.$emit("onUploadApk");
          this.loading = false;
          this.$message.warning("上传成功");
        }
      });
    },
    getProgress() {
      console.log("将进度条打开");
      //将进度条打开
      this.isTrue = true;
      //此方法的开始，将percentage赋值0
      this.percentage = 0;

      //访问后台，获取滚动条数据
      //每隔 0.1秒访问一次后台，获取一次进度条数据
      let time = setInterval(() => {
        //调用 获取进度条的方法
        this.getJD();

        if (this.percentage >= 99) {
          clearInterval(time);
          this.isTrue = false;
          this.percentage = 0;
        }
      }, 100);
    },
    async getJD() {
      await this.axios.get("/game/getJD").then(resp => {
        this.percentage = resp.data;
      });
    }
  }
};
</script>

<style scoped></style>
